export const PAGE_HEADER_HEIGHT = 57;
export const PAGE_PADDING = 20;
export const PAGE_TOOLBARS_HEIGHT = 44;
export const PAGE_FOOTER_HEIGHT = 56;



export const GRID_HEADER_HEIGHT = 34;
export const GRID_FILTER_ROW_HEIGHT = 34;
export const GRID_FILTER_PANEL_HEIGHT = 40;
export const GRID_PAGER_HEIGHT = 55;